

export const frontMatter = {};
export const contentTitle = 'AggregationLayer (Experimental)';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-api-reference-aggregation-layers-aggregation-layer-md-209.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Methods",
  "id": "methods",
  "level": 2
}, {
  "value": "<code>getAggregatorType</code>",
  "id": "getaggregatortype",
  "level": 4
}, {
  "value": "<code>createAggregator</code>",
  "id": "createaggregator",
  "level": 4
}, {
  "value": "<code>onAttributeChange</code>",
  "id": "onattributechange",
  "level": 4
}, {
  "value": "<code>renderLayers</code>",
  "id": "renderlayers",
  "level": 4
}, {
  "value": "Source",
  "id": "source",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h1: "h1",
    h2: "h2",
    h4: "h4",
    header: "header",
    li: "li",
    p: "p",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "aggregationlayer-experimental",
        children: "AggregationLayer (Experimental)"
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "AggregationLayer"
      }), " is the base class for all layers in ", _jsx(_components.code, {
        children: "@deck.gl/aggregation-layers"
      }), " module. It implements the most common tasks for aggregation with flexibility of customizations."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "AggregationLayer"
      }), " extends ", _jsx(_components.a, {
        href: "/docs/api-reference/core/composite-layer",
        children: "CompositeLayer"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "methods",
      children: "Methods"
    }), "\n", _jsxs(_components.p, {
      children: ["Any layer subclassing the ", _jsx(_components.code, {
        children: "AggregationLayer"
      }), " must implement the following methods:"]
    }), "\n", _jsx(_components.h4, {
      id: "getaggregatortype",
      children: _jsx(_components.code, {
        children: "getAggregatorType"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Returns a string that indicates the type of aggregator that this layer uses, for example ", _jsx(_components.code, {
        children: "'gpu'"
      }), ". The aggregator type is re-evaluated every time the layer updates (usually due to props or state change). If the type string does not match its previous value, any existing aggregator will be disposed,and ", _jsx(_components.code, {
        children: "createAggregator"
      }), " is called to create a new instance."]
    }), "\n", _jsx(_components.h4, {
      id: "createaggregator",
      children: _jsx(_components.code, {
        children: "createAggregator"
      })
    }), "\n", _jsx(_components.p, {
      children: "Arguments:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "type"
        }), " (string) - return value from ", _jsx(_components.code, {
          children: "getAggregatorType()"
        })]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Returns a ", _jsx(_components.a, {
        href: "/docs/api-reference/aggregation-layers/aggregator",
        children: "Aggregator"
      }), " instance. This instance will be accessible via ", _jsx(_components.code, {
        children: "this.state.aggregator"
      }), "."]
    }), "\n", _jsx(_components.h4, {
      id: "onattributechange",
      children: _jsx(_components.code, {
        children: "onAttributeChange"
      })
    }), "\n", _jsx(_components.p, {
      children: "Arguments:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "attributeId"
        }), " (string) - the id of an attribute that has been updated"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["This event handler should be used to update the props of the aggregator, if needed, and call ", _jsx(_components.code, {
        children: "aggregator.setNeedsUpdate"
      }), " to request an update."]
    }), "\n", _jsx(_components.h4, {
      id: "renderlayers",
      children: _jsx(_components.code, {
        children: "renderLayers"
      })
    }), "\n", _jsx(_components.p, {
      children: "Returns a list of sub layers."
    }), "\n", _jsxs(_components.p, {
      children: ["Aggregation results can be obtained here with ", _jsx(_components.code, {
        children: "aggregator.getBins"
      }), ", ", _jsx(_components.code, {
        children: "aggregator.getResult"
      }), " and ", _jsx(_components.code, {
        children: "aggregator.getResultDomain"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "source",
      children: "Source"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.a, {
        href: "https://github.com/visgl/deck.gl/tree/9.4-release/modules/aggregation-layers/src/common/aggregation-layer.ts",
        children: "modules/aggregation-layers/src/common/aggregation-layer.ts"
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

